import React from "react";
import style from "../../styles/pujaDetails.module.css";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import HeadingPuja from "./HeadingPuja";
const BenefitsPuja = ({
  data,
  isAdmin
}) => {
  const {
    t
  } = useTranslation();
  if (!data || !data.EventBenefitRelations || data.EventBenefitRelations.length === 0) {
    return null;
  }
  return <div className={style.pujaSectionContainer} data-sentry-component="BenefitsPuja" data-sentry-source-file="BenefitsPuja.jsx">
      <HeadingPuja headline={t("benefits-of-puja")} data-sentry-element="HeadingPuja" data-sentry-source-file="BenefitsPuja.jsx" />
      <div className={style.pujaBenefitItems}>
        {data.EventBenefitRelations.map((benefit, index) => {
        if (benefit.EventBenefit && benefit.EventBenefit.benefitImage && benefit.EventBenefit.benefitName && benefit.EventBenefit.benefitDescription) {
          return <div key={index} className={style.benefitDiv}>
                <div className={style.benefitIcon}>
                  <Image src={benefit.EventBenefit.benefitImage} alt={benefit.EventBenefit.benefitName} width={90} height={90} style={{
                borderRadius: "15px"
              }} loading="lazy" />
                </div>
                <div className={style.benefitTextContainer}>
                  <div className={style.benefitHead}>
                    {benefit.EventBenefit.benefitName}
                  </div>
                  <div className={style.benefitDes}>
                    {benefit.EventBenefit.benefitDescription}
                  </div>
                </div>
              </div>;
        } else {
          return null;
        }
      })}
      </div>
    </div>;
};
export default BenefitsPuja;